import AccessibleCard from '../../_global/js/accessibleCard';

export default function _card() {
    /**
     * Component wrapper selector
     * @const {string}
     */
    const CARD_SELECTOR = '[data-component="card"]';

    /**
     * Card item selector
     * @const {string}
     */
    const CARD_ITEM_SELECTOR = '.card';

    /**
     * Card link selector
     * @const {string}
     */
    const CARD_LINK_SELECTOR = '.card__link';

    class Card {
        constructor(component) {
            this.cardWrapper = component;

            component.querySelectorAll(CARD_ITEM_SELECTOR).forEach((item) => {
                const DOMItem = item;
                const link = item.querySelector(CARD_LINK_SELECTOR);

                if (!DOMItem.component) {
                    DOMItem.component = new AccessibleCard(item, link);
                }
            });
        }
    }

    const components = document.querySelectorAll(CARD_SELECTOR);
    components.forEach((component) => {
        const DOMItem = component;

        // Attach the instance to the DOM once
        if (!DOMItem.component) {
            DOMItem.component = new Card(component);
        }
    });
}

_card();

export function formatCardTexts() {
    const resourceCards = document.querySelectorAll(
        '.resource-tile__container'
    );

    resourceCards.forEach((resourceCard) => {
        // FRONT CONTENT
        const frontTitle = resourceCard.querySelector(
            '.resource-tile__front .resource-tile__title'
        );
        const frontTitleHeight = Math.ceil(frontTitle.offsetHeight);
        const frontText = resourceCard.querySelector(
            '.resource-tile__front .resource-tile__text'
        );

        // BACK CONTENT
        const backTitle = resourceCard.querySelector(
            '.resource-tile__back .resource-tile__title'
        );
        const backTitleHeight = Math.ceil(backTitle.offsetHeight);
        const backText = resourceCard.querySelector(
            '.resource-tile__back .resource-tile__text'
        );

        const cardTextResize = () => {
            if (frontTitle) {
                if (frontTitleHeight <= 33) {
                    frontText.style.cssText = '-webkit-line-clamp: 4;';
                }
                if (frontTitleHeight > 33 && frontTitleHeight <= 64) {
                    frontText.style.cssText = '-webkit-line-clamp: 3;';
                }
                if (frontTitleHeight > 64) {
                    frontText.style.cssText = '-webkit-line-clamp: 2;';
                }
            }

            if (backTitle) {
                if (backTitleHeight <= 74) {
                    backText.style.cssText = '-webkit-line-clamp: 5;';
                }
                if (backTitleHeight > 74 && backTitleHeight < 109) {
                    backText.style.cssText = '-webkit-line-clamp: 5;';
                }
                if (backTitleHeight > 109) {
                    backText.style.cssText = '-webkit-line-clamp: 3;';
                }
            }
        };

        cardTextResize();

        window.addEventListener('resize', () => {
            cardTextResize();
        });
    });
}

if (window.matchMedia('(min-width: 1024px)')) {
    window.addEventListener('DOMContentLoaded', formatCardTexts);
}
